import ContentLoader from 'react-content-loader';

import { useSkeletonColors } from 'hooks';

export default function PaymentsHistoryLoader() {
  const skeletonColors = useSkeletonColors();

  return (
    <ContentLoader
      speed={2}
      {...skeletonColors}
      height="220px"
    >
      <rect x="0" y="0" rx="3" ry="3" width="100%" height="220px" />
    </ContentLoader>
  );
}
